var App = App || {};

App.Locations = (function ($) {
    'use strict';

    function init() {

        $(document).on('click', '#typebar-LocationsConnectorWebsiteBranch', function () {
            if (this.checked) {
                $('#LocationsConnectorWebsiteBranch').checked = true;
            }
            else {
                $('#LocationsConnectorWebsiteBranch').checked = false;
            }
            $('.component-locations-form-filters-buttons div:first button').click();
        });

        $(document).on('click', '#typebar-LocationsConnectorWebsiteITM', function () {
            if (this.checked) {
                $('#LocationsConnectorWebsiteITM').checked = true;
            }
            else {
                $('#LocationsConnectorWebsiteITM').checked = false;
            }
            $('.component-locations-form-filters-buttons div:first button').click();
        });

        $(document).on('click', '#typebar-LocationsConnectorSurFree', function () {
            if (this.checked) {
                $('#LocationsConnectorSurFree').checked = true;
            }
            else {
                $('#LocationsConnectorSurFree').checked = false;
            }
            $('.component-locations-form-filters-buttons div:first button').click();
        });

        $(document).on('click', '#typebar-LocationsConnectorDeposit', function () {
            if (this.checked) {
                $('#LocationsConnectorDeposit').checked = true;
            }
            else {
                $('#LocationsConnectorDeposit').checked = false;
            }
            $('.component-locations-form-filters-buttons div:first button').click();
        });

    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Locations.init();
});